
  import { css } from 'lit';
  export const styles = css`:host([variant=danger]) [part~=base]{background:var(--ig-error-700)}:host([variant=success]) [part~=base]{background:var(--ig-success-900)}:host([variant=info]) [part~=base]{background:var(--ig-info-800)}`;
  